/**
 * According to documentation, this Component Wraps Button from Chakra ui
 * and allows to override shouldForwardProp option on native tag `button`
 * in order to avoid pass custom props defined in CUSTOM_PROPS constant
 * see: https://chakra-ui.com/docs/styled-system/chakra-factory#allowing-custom-props-to-be-forwarded
 */
import React from 'react';
import {
  chakra,
  shouldForwardProp,
  Button as ChakraButton,
} from '@chakra-ui/react';
import { useController } from './hooks/useController';

const CUSTOM_PROPS = ['animationType'];

const ButtonWithCustomProps = chakra('button', {
  shouldForwardProp: (prop) => {
    const isChakraProp = !shouldForwardProp(prop);
    if (isChakraProp) return false;

    const isButtonCustomProp = CUSTOM_PROPS.includes(prop);
    if (isButtonCustomProp) return false;

    return true;
  },
});

export const Button = (props) => {
  const {
    children: originalChildren,
    ...otherProps
  } = props;
  const {
    children,
  } = useController({
    children: originalChildren,
  });

  return (
    <ChakraButton
      as={ButtonWithCustomProps}
      {...otherProps}
    >
      {children}
    </ChakraButton>
  );
};
